import React, { FC, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import StyledButton from 'components/Button';
import InteractiveHint from 'components/InteractiveHint';
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { dateRangeState, roomQuantityState, guestQuantityState, childrenQuantityState } from 'states/SearchBarStates/atoms';
import { isToday } from 'functions/dates';
import { 
  selectedRooms,
  couponState,
  couponSuccessState,
  ratePlanChoice,
  totalPayNowState, 
  totalPayAtCheckInState
} from 'states/CheckOutStates/atoms';
import { useGetBookingAddOns } from 'customHooks/useGetBookingAddOns';
import { ADVANCED, ADVANCED_RATE } from 'constants/ratePlanId';
import { dateDiff } from 'utils/util';
import { addOnOptionsState } from 'states/OptionStates/atoms';
import { BookingOverlay, BookingSummaryContainer, BookingSummarySlot } from '../../style';
//import { BookingSummaryContainer } from './style';
import moment from 'moment';
import { HST_RATE, MAT_RATE } from 'constants/constant';
import { PriceQuestionIcon } from 'assets/icons';
import { colors } from 'constants/colors';
import { ReactNode } from 'react';
import { useMobileBookingSummary } from 'customHooks/useMobileBookingSummary';
import CouponInputBlock from "components/CouponInputBlock";
import { styleSizes, styleSizesNumber } from 'constants/styleSizes';
import useWindowSize from "customHooks/useWindowSize"; 

const debug = false;

const BookingSummary: FC<{handleCheckOut: ()=> void, loading: boolean}> = ({handleCheckOut, loading}) => {

  useHistory()

  
  const setTotalPayNow = useSetRecoilState(totalPayNowState);
  const setTotalPayAtCheckIn = useSetRecoilState(totalPayAtCheckInState);

  const { width: windowWidth } = useWindowSize();
  
  const persistSelectedRooms = useRecoilValue(selectedRooms)
  const roomQuantity = useRecoilValue(roomQuantityState)
  const guestQuantity = useRecoilValue(guestQuantityState)
  useRecoilValue(childrenQuantityState)
  const dateRange = useRecoilValue(dateRangeState)
  
  const hideRateVariants = isToday(dateRange[0]);

  if (debug)  {
    console.log ('hideRateVariants = ', hideRateVariants);
  }
  
  // customer selected addOns
  const addOnOptions = useRecoilValue(addOnOptionsState);
  const ratePlanId = useRecoilValue(ratePlanChoice)
  // all addOns query from server
  const bookingAddOns = useGetBookingAddOns()
  const [summaryText, setSummaryText] = useState<ReactNode>(null);
  const { isOverlay, panelRef, handleRef, slotRef, detailsRef, toggle, close } = useMobileBookingSummary();


  
  const coupon = useRecoilValue(couponState)
  const couponSuccess = useRecoilValue(couponSuccessState)

  // const [coupon, setCoupon] = useRecoilState(couponState)
  // const [couponInput, setCouponInput] = useState(coupon.couponCode || '')
  // const [couponError, setCouponError] = useState(false)
  // const [couponSuccess, setCouponSuccess] = useRecoilState(couponSuccessState)

  // const successMessage = 'Success! Coupon code applied.'
  // const errorMessage = 'Coupon code is invalid'

  
  // const [applyCoupon] = useLazyQuery(APPLY_COUPON, {
  //   onCompleted: (couponQueryData) => {
  //     if(couponQueryData.couponByCode?.isActive) {
  //       setCouponError(false)
  //       setCouponSuccess(true)
  //       setCoupon(couponQueryData.couponByCode)
  //       localStorage.setItem("coupon", JSON.stringify(couponQueryData.couponByCode))
  //     } else {
  //       setCouponError(true)
  //       setCouponSuccess(false)
  //       setCouponInput('')
  //     }
  //   },
  //   onError: (error) => {
  //     setCouponError(true)
  //     setCouponSuccess(false)
  //     setCouponInput('')
  //   }
  // })

  const nights = dateDiff(new Date(dateRange[0]), new Date(dateRange[1]))
  const roomFee = (persistSelectedRooms.pricePerNight || 0) * nights * roomQuantity
  const addOnFee = bookingAddOns.reduce((acc, addOn) => {
    if (addOnOptions.includes(addOn.addOnId)) {
      if(addOn.isOneTimePriced) {
        return acc + (addOn.pricePerNight || 0) * roomQuantity
      } else {
        return acc + (addOn.pricePerNight || 0) * nights * roomQuantity
      }
    }
    return acc
  }
  , 0)

  const couponDiscount = coupon.rateType==='FIXED_RATE'? (coupon.discount || 0): (coupon.discount || 0) / 100 * roomFee
  const ratePlanDiscount = ratePlanId === ADVANCED ? coupon.rateType === 'FIXED_RATE' ? (roomFee - (coupon.discount || 0)) * (1 - ADVANCED_RATE) : roomFee * (1 - (coupon.discount || 0) / 100) * (1 - ADVANCED_RATE) : 0
  // const discountedRoomFee = coupon.rateType === 'FIXED_RATE' ? (roomFee - (coupon.discount || 0)) * (ratePlanId === ADVANCED ? ADVANCED_RATE : 1) : roomFee * (1 - (coupon.discount || 0) / 100) * (ratePlanId === ADVANCED ? ADVANCED_RATE : 1)

  // const subtotal = discountedRoomFee + addOnFee
  // const MAT = discountedRoomFee * MAT_RATE
  // const HST = (subtotal + MAT) * HST_RATE
  // const total = subtotal + MAT + HST

// base discounted fee without considering ratePlanId
const baseDiscountedRoomFee =
  coupon.rateType === "FIXED_RATE"
    ? roomFee - (coupon.discount || 0)
    : roomFee * (1 - (coupon.discount || 0) / 100);

// Pay Now 
const discountedRoomFeePayNow = baseDiscountedRoomFee  * ADVANCED_RATE;

// Pay at Check-in 
const discountedRoomFeePayAtCheckIn = baseDiscountedRoomFee;

// generic total
const discountedRoomFee =
  coupon.rateType === "FIXED_RATE"
    ? (roomFee - (coupon.discount || 0)) *
      (ratePlanId === ADVANCED ? ADVANCED_RATE : 1)
    : roomFee *
      (1 - (coupon.discount || 0) / 100) *
      (ratePlanId === ADVANCED ? ADVANCED_RATE : 1);

const subtotal = discountedRoomFee + addOnFee;
const MAT = discountedRoomFee * MAT_RATE;
const HST = (subtotal + MAT) * HST_RATE;
const total = subtotal + MAT + HST;

// Pay Now total 
const subtotalPayNow = discountedRoomFeePayNow + addOnFee;
const MATPayNow = discountedRoomFeePayNow * MAT_RATE;
const HSTPayNow = (subtotalPayNow + MATPayNow) * HST_RATE;
const totalPayNow = subtotalPayNow + MATPayNow + HSTPayNow;

// Pay at Check-in total 
const subtotalPayAtCheckIn = discountedRoomFeePayAtCheckIn + addOnFee;
const MATPayAtCheckIn = discountedRoomFeePayAtCheckIn * MAT_RATE;
const HSTPayAtCheckIn =
  (subtotalPayAtCheckIn + MATPayAtCheckIn) * HST_RATE;
const totalPayAtCheckIn =
  subtotalPayAtCheckIn + MATPayAtCheckIn + HSTPayAtCheckIn;

  // save to recoil to use in other components
  useEffect(() => {
    setTotalPayNow(totalPayNow);
    setTotalPayAtCheckIn(totalPayAtCheckIn);
  }, [totalPayNow, totalPayAtCheckIn, setTotalPayNow, setTotalPayAtCheckIn]);



  // const handleCouponApply = () => {
  //   if (couponInput.length) {
  //     applyCoupon({
  //       variables: {
  //         couponCode: couponInput.toUpperCase()
  //       }
  //     })
  //   }
  // }


  // const [noWindowCheckBoxText, setNoWindowCheckBoxText] = useState('');

  useEffect (()=> {

    if (debug) {
      console.log ("persistSelectedRooms step 2:", persistSelectedRooms);
    }

    // let windowCheckBoxText = "";
  
    // if (!persistSelectedRooms.hasWindows) {
    //   windowCheckBoxText = "I understand that I am receiving a discounted rate because I am booking a room which does not have a window, and the only natural source of light in this room is a skylight.";
      
    //   if (persistSelectedRooms.name === "Bishop Inside") {
    //     windowCheckBoxText = "I understand that I am receiving a discounted rate because I am booking a room which does not have a window or a skylight.";
    //   }
    // }
  
//setNoWindowCheckBoxText(windowCheckBoxText);

    setSummaryText(
      <>
        {persistSelectedRooms.name} - {persistSelectedRooms.bed}
        {persistSelectedRooms.hasWindows
          ? " w/ window"
          : persistSelectedRooms.name === "Bishop Inside"
          ? " no/ window"
          : " w/ skylight"}
        {" " + roomQuantity * nights + " @ $" + persistSelectedRooms.pricePerNight}
      </>
    );


  }, [persistSelectedRooms, nights, roomQuantity])


  return (
    <>
    <BookingOverlay
    className={isOverlay ? 'visible' : ''}
    onClick={close}
    />
      {windowWidth > styleSizesNumber.miniBreakpoint &&
        windowWidth <= styleSizesNumber.tabletBreakpoint && (
          <div className="tabletTitle">
            Your booking summary
            <div className="tabletSubTitle">
              Please review your stay details.
            </div>
          </div>
        )}
      <BookingSummarySlot ref={slotRef} className={isOverlay ? 'reserved' : ''} aria-hidden="true" />
      <BookingSummaryContainer
        ref={panelRef}
        className={`checkoutBookingSummary lastStep mobileFlowSummary ${isOverlay ? 'summaryOverlay' : ''}`}
      >
    <div
        className="swipeToHide"
        ref={handleRef}
        role="button"
        tabIndex={0}
        aria-expanded={isOverlay}
        onClick={toggle}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        }}
      >
      {isOverlay ? 'Tap here to hide details' : 'Tap here to show details'}
        <div className="swipeToHideHr"></div>
    </div>
    <div className="bookingMobileContentDetails" ref={detailsRef}>
        <div className="flowSummaryTitle flowSummaryTitleOnly">Your booking summary</div>

        {windowWidth > parseInt(styleSizes.miniBreakpoint, 10) && (
          <CouponInputBlock />
        )}
        <div className="separator separatorCoupon"></div>
        <table cellPadding={0} cellSpacing={0} border={0} className="datesTable">
          <tr>
            <td className='hdr' width="100%">DATES</td>
            <td className="hdr">ROOMS / GUESTS</td>
          </tr>
          <tr>
            <td  className="data">
            {moment(dateRange[0]).format('MMM Do YYYY')}&nbsp;-&nbsp;
            {moment(dateRange[1]).format('MMM Do YYYY')}
            {/* &nbsp;&nbsp;&nbsp;
            <span
            className='editTrip'
            onClick={() => {
              history.push(`/search?checkInDate=${dateRange[0]}&checkOutDate=${dateRange[1]}&guestQuantity=${guestQuantity}&roomQuantity=${roomQuantity}`);
            }}
          >
            Edit
          </span> */}
            </td>
            <td className="data dataRt">{roomQuantity + '/' + guestQuantity}
            {/* &nbsp;&nbsp;&nbsp;
            <span
            className='editTrip'
            onClick={() => {
              history.push(`/search?checkInDate=${dateRange[0]}&checkOutDate=${dateRange[1]}&guestQuantity=${guestQuantity}&roomQuantity=${roomQuantity}`);
            }}
          >
            Edit
          </span> */}
            </td>
          </tr>
        </table>

        <div className="separator"></div>

        <div className="booking">BREAKDOWN</div>


        <table cellPadding={0} cellSpacing={0} border={0} className="breakdownTable">
          <tr>
            <td className="roomNights">{roomQuantity} {roomQuantity === 1 ? 'Room' : 'Rooms'} – {nights} {nights === 1 ? 'Night' : 'Nights'}</td>
            <td></td>
          </tr>
          <tr>
            <td className="line">
              <span className="label">
              {summaryText}
              </span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${roomFee.toFixed(2)}
            </td>
          </tr>
          {ratePlanId===ADVANCED && (
          <tr>
          <td className="line">
          <span className="redMark">Advanced Purchase (10% off)</span>
              <span className="dots"></span>
          </td>
          <td className="price">
          <span className="redMark">-${ratePlanDiscount.toFixed(2)}</span>
          </td>
        </tr>
          )}
          {couponSuccess && (
          <tr>
            <td className="line">
                <span className="redMark label">{`Coupon (${coupon.rateType==='FIXED_RATE'? '$'+ coupon.discount + ' off': coupon.discount + '% off'})`}</span>
                <span className="dots"></span>
            </td>
            <td className="price">
              <span className="redMark">-${couponDiscount.toFixed(2)}</span>
            </td>
          </tr>
          )}
          <tr>
            <td className="line">
              <span className="label">Municipal Accommodation Tax (6%)
              <InteractiveHint
                content={
                  (
                    <div>
                      <div>
                        <span
                          style={{
                            color: colors.hoverBlue,
                            fontSize: '14px',
                            lineHeight: '18px',
                            fontWeight: 600,
                            fontStyle: 'italic',
                            fontFamily: 'Titillium Web',
                          }}
                        >
                          {'What is this?\u00A0\u00A0'}
                        </span>
                        <span
                          style={{
                            color: colors.black,
                            fontSize: '14px',
                            lineHeight: '18px',
                            fontFamily: 'Titillium Web',
                          }}
                        >
                          The Municipal Accommodation Tax is applied by the city of Mississauga on all hotel room rentals. The tax is 6% of the lodging cost, and is not applied to any other amenities. All hotels in Mississauga are obligated to charge this tax.
                        </span>
                      </div>
                    </div>
                  )
                }
              >
                <PriceQuestionIcon />
              </InteractiveHint>  

              </span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${MAT.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
          <tr>
            <td className="line">
              <span className="label">HST (13%)
              <InteractiveHint
                content={
                  (
                    <div>
                      <div>
                        <span
                          style={{
                            color: colors.hoverBlue,
                            fontSize: '14px',
                            lineHeight: '18px',
                            fontWeight: 600,
                            fontStyle: 'italic',
                            fontFamily: 'Titillium Web',
                          }}
                        >
                          {'What is this?\u00A0\u00A0'}
                        </span>
                        <span
                          style={{
                            color: colors.black,
                            fontSize: '14px',
                            lineHeight: '18px',
                            fontFamily: 'Titillium Web',
                          }}
                        >
                          The Harmonized Sales Tax (HST) is a 13% tax applied by the Government of Ontario on all sales which take place in Ontario, Canada.
                        </span>
                      </div>
                    </div>
                  )
                }
              >
                <PriceQuestionIcon />
              </InteractiveHint>  

              </span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${HST.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>

          <tr>
            <td className="total">TOTAL</td>
            <td className="total price totalPrice">
            ${total.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
        </table>

          
        { (!hideRateVariants && ratePlanId===ADVANCED) ? (
          <>
        <div className='separator'></div>
        <table cellPadding={0} cellSpacing={0} border={0} className="totalTable">
        <tr>
            <td className="total topPart">PAY AT CHECK IN</td>
            <td className="total price totalPrice">
            ${totalPayAtCheckIn.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
          <tr>
            <td className="total">PAY NOW</td>
            <td className="total price payNow totalPrice">
            ${totalPayNow.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
        </table>
        </>
        ): null }

    { (!hideRateVariants && ratePlanId!==ADVANCED) ? (
        <table cellPadding={0} cellSpacing={0} border={0} className="totalTable">
        <tr>
            <td className="total">PAY AT CHECK IN</td>
            <td className="total price payNow totalPrice">
            ${totalPayAtCheckIn.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
        </table>
        ): null }

      
</div>


<div className="controls noControls">
        <div className="mobileTotals">
          <div className="closedContent">
          <div className="mobileTotalsTotal">Total <span>
            ${total.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </span></div>
          <div className="mobileTotalsGuests">Guests/Rooms <span>{guestQuantity}/{roomQuantity}</span></div>
          </div>
        </div>
        {windowWidth <= parseInt(styleSizes.miniBreakpoint, 10) && (
          <div className="controlsButton">

              <StyledButton
                className="checkOutButton"
                width="156px"
                height="48px"
                fontSize={16}
                disabled={loading}
                loading={loading}
                onClick={handleCheckOut}
              >
                {loading ? '' : 'Confirm & Book'}
              </StyledButton>
            
          </div>
          )}
        </div>

        {ratePlanId !== ADVANCED && !hideRateVariants && (
          <div className="yourCardWillNotBeCharged">
            Your card will not be charged until check in.
          </div>
        )}





       {/* <div className='couponContainer'>
         <FormInputField
           label="COUPON"
           error={couponError}
           errorMessage={errorMessage}
           success={couponSuccess}
           successMessage={successMessage}
           borderColor={colors.signInBorderColor}
           labelColor={colors.noBookingText}
           labelWeight='400'
           onChange={(e) => {
             setCouponInput(e.target.value)
             if(couponError) {
               setCouponError(false)
             }
             if(couponSuccess) {
               setCouponSuccess(false)
             }
           }}
           onKeyDown={(e) => {
             if (e.key === 'Enter') {
               handleCouponApply()
             }
           }}
           value={couponInput}
           inputHeight="48px"
         />
         <StyledButton
           className="applyCouponButton"
           width="122px"
           height="48px"          
           onClick={handleCouponApply}
         >
           Apply
         </StyledButton>
       </div> */}

    </BookingSummaryContainer>
    </>
  )
}

export default BookingSummary